/*
 * numberGroup
 * Formats numbers in groups of three, starting from the right-most position.
 *
 * Output examples:
 * 123    => 123
 * 1234   => 1 234
 * 12345  => 12 345
 * 123456 => 123 456
 */

const numberGroup = (price) => {
  const reversedChars = String(price)
    .split('')
    .reverse()
  const spacedChars = reversedChars.map((character, i) => {
    if (i > 0 && i % 3 === 0) {
      return `${character} `
    }
    return character
  })
  return spacedChars.reverse().join('')
}

const rgbToHex = (r, g, b) =>
  `#${[r, g, b]}`
    .map((x) => {
      const hex = x.toString(16)
      return hex.length === 1 ? `0${hex}` : hex
    })
    .join('')

const hexToRgb = (hex) =>
  `rgb(${hex
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16))
    .join(', ')})`

export { numberGroup, rgbToHex, hexToRgb }
